<template>
  <div class="page">
  </div>
</template>
<script>
export default {
  name: 'page',
}
</script>
